export default __webpack_public_path__ + "static/media/laporan-planogram.cf70ba4a.png";